const pad = (value: number) => String(value).padStart(2, '0');

/** A name for a text file saved today, such as lyrmo-more-natural-2026-09-27.txt. */
export function textFileName(title: string, date = new Date()): string {
  const slug = title
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, '-')
    .replace(/^-|-$/g, '');
  const day = `${String(date.getFullYear())}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  return `lyrmo-${slug}-${day}.txt`;
}

/** Saves `text` as a UTF-8 file called `name`, plain text unless said, through the browser's downloads. */
export function downloadText(name: string, text: string, type = 'text/plain'): void {
  const url = URL.createObjectURL(new Blob([text], { type: `${type};charset=utf-8` }));
  const link = document.createElement('a');
  link.href = url;
  link.download = name;
  link.hidden = true;
  // Some browsers only follow links that are in the document.
  document.body.append(link);
  link.click();
  link.remove();
  // Revoking straight away can cancel the download in some browsers.
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 1_000);
}
